<template>
<div class="box-labour">
    <div class="box-box">
        <div class="nav">
            <router-link to="AdministrativeHome"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
            合同申请
            <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
        </div>
        <div class="issueContent">
            <div v-for="(item, i) in dataList1" :key="i">
                <p class="titleClass" id="titleCotent">{{item.title}}</p>
                <img src="../../assets/you.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent(i)">
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            addShowJia: true,
            addShowXia: false,
            showContent: false,
            addShowJia1: true,
            addShowXia1: false,
            showContent1: false,
            dataList1: [{
                    title: "1. 适用范围与合同规范"
                },{
                    title: "2. 申请流程"
                },]
        };
    },
    methods: {
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "1003"
                }
            })
        },
        
        addGetContent(i){
            if(i == 0){
                this.$router.push({name:"Administrative3",params:{code:"99"}})
            }else if(i == 1) {
                this.$router.push({name:"Administrative9",params:{code:'13'}})
            }
        },
    }
};
</script>

<style scoped>
.box-labour {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
}

.box-box {
    background: rgba(244, 244, 244, 1);
}
.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.issueContent {
    width: 90%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.3);
    border-radius: 10px;
    overflow: hidden;
}

.issueContent div {
    width: 100%;
    height: 56px;
    border-bottom: 1px solid #ededed;
}

.issueContent div:last-child {
    border-bottom: 0;
}

.issueContent div .titleClass {
    width: 63%;
    float: left;
    color: #838383;
    margin: 18px 0 18px 24px;
}

.issueContent div .ImgClassDian {
    width: 18px !important;
}

.issueContent div #titleCotent {
    width: 80% !important;
    margin-left: 33px !important;
    font-size: 15px;
}

.issueContent div img {
    width: 21px;
    float: right;
    margin: 18px 10px 18px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Administrative/administrative10.vue